<template>
  <div class="card">
    <div class="card-header">
      <h4>{{ type }}</h4>
    </div>
    <div class="card-body">
      <div>
        <p class="text-muted">Лиды в оплаты (за период)</p>
        <p><strong>{{ data.total }}</strong> <i class="icon-fa icon-fa-arrow-right"/>
          <strong>{{ data.confirmed }}</strong> (<strong>{{ Math.round(data.confirmed * 100 / data.total * 10) / 10 }}
            %</strong>)</p>
      </div>
      <div class="row border">
        <div class="col-md-6 border-right">
          <p>Оформили заказ</p>
          <p><strong>{{ data.total }}</strong></p>
        </div>
        <div class="col-md-6">
          <p>Отказ у менеджера (звонок)</p>
          <p><strong>{{ data.rejectedB4Requisites }} (<strong>{{
              Math.round(data.rejectedB4Requisites * 100 / data.total * 10) / 10
            }} %</strong>)</strong></p>
        </div>
      </div>
      <div class="row border">
        <div class="col-md-6 border-right">
          <p>Выданы реквизиты на оплату</p>
          <p><strong>{{ data.total - data.rejectedB4Requisites }}</strong></p>
        </div>
        <div class="col-md-6">
          <p>Отказ от оплаты</p>
          <p><strong>{{ data.rejectedAfterRequisites }} (<strong>{{
              Math.round(data.rejectedAfterRequisites * 100 / (data.total - data.rejectedB4Requisites) * 10) / 10
            }} %</strong>)</strong></p>
        </div>
      </div>
      <div class="row border">
        <div class="col-md-6 border-right">
          <p>Оплачены</p>
          <p><strong>{{ data.confirmed }}</strong></p>
        </div>
        <div class="col-md-6">
        </div>
      </div>
<!--      {{ data }}-->
    </div>
  </div>
</template>
<script>

export default {
  props: ['data', 'type']
}
</script>

<style scoped>
p {
  margin-bottom: 1px;
}
</style>
